import * as React from 'react';
import { MainWrapperAdsV2 } from './main-3-ads-wrapper-v2.js';
import { PageChangeUpdatePageJsonHook } from './utils/json-page-change.js';

const _MainJson = () => {
  const pageJson = PageChangeUpdatePageJsonHook();
  return <MainWrapperAdsV2 pageJson={pageJson} />;
};
/** We need to use this as otherwise we have additional renders take place */
export const MainJsonV2 = React.memo(_MainJson);
